<template>
  <VCard>
    <VCardTitle>
      Let's Debug Login
      <VBtn small class="ml-2" color="primary" @click="updateLetsDebugLoginData">
        Update LetsDebugLoginData
      </VBtn>
      <VCheckbox
        v-model="closeDialogAfterLogin"
        label="Close Dialog after login"
        hide-details="auto"
        @click="closeDialogAfterLogin = !closeDialogAfterLogin"
      />
    </VCardTitle>
    <VCardText>
      <div class="login-grid">
        <div
          v-for="(item, index) in LoginPreset"
          :key="index"
          class="login-grid-item"
          @click="login(item)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="my-2 d-flex align-center">
        <VTextField
          ref="customLoginNo"
          label="login with xxx_no"
          hide-details="auto"
        />
        <VBtn small color="primary" class="mr-2" @click="loginWithCustomNo('student_no=')">student_no</VBtn>
        <VBtn small color="primary" class="mr-2" @click="loginWithCustomNo('teacher_no=')">teacher_no</VBtn>
        <VBtn small color="primary" @click="loginWithCustomNo('user_no=')">user_no</VBtn>
      </div>
      <div class="my-2 d-flex align-center">
        <VTextField
          ref="customLoginUserId"
          label="login with user_id"
          hide-details="auto"
        />
        <VBtn small color="primary" class="mr-2" @click="loginWithUserId()">user_id</VBtn>
      </div>
    </VCardText>
  </VCard>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      closeDialogAfterLogin: true,
    };
  },
  computed: {
    LoginPreset() {
      return [
        { title: "560 Admin", user_type_code: 560 },
        { title: "550 センター長", user_type_code: 550 },
        { title: "540 事務スタッフ", user_type_code: 540 },
        { title: "530 担当者", user_type_code: 530 },
        { title: "520 営業", user_type_code: 520 },
        { title: "410 教室(オンライン教室)", user_type_code: 410 },
        { title: "420 教室（直営）", user_type_code: 420 },
        { title: "430 教室（FC）", user_type_code: 430 },
        { title: "300 Teacher", user_type_code: 300 },
        { title: "110 Student", user_type_code: 110 },
        { title: "120 Student", user_type_code: 120 },
        { title: "130 Student", user_type_code: 130 },
        { title: "110 Student Have Class Today", user_type_code: 110,haveClass:moment().format("YYYY-MM-DD") },
        { title: "120 Student Have Class Today", user_type_code: 120,haveClass:moment().format("YYYY-MM-DD") },
        { title: "130 Student Have Class Today", user_type_code: 130,haveClass:moment().format("YYYY-MM-DD") },
        { title: "300 Teacher Have Class Today", user_type_code: 300,haveClass:moment().format("YYYY-MM-DD") },
        { title: "110 Student Have Class Today(Random)", user_type_code: 110,haveClass:moment().format("YYYY-MM-DD"), index: "random" },
        { title: "120 Student Have Class Today(Random)", user_type_code: 120,haveClass:moment().format("YYYY-MM-DD"), index: "random" },
        { title: "130 Student Have Class Today(Random)", user_type_code: 130,haveClass:moment().format("YYYY-MM-DD"), index: "random" },
        { title: "300 Teacher Have Class Today(Random)", user_type_code: 300,haveClass:moment().format("YYYY-MM-DD"), index: "random" },
        ...this.LetsDebugLoginData
      ];
    },
    LetsDebugLoginData: {
      get () {
        const data = localStorage.getItem('LetsDebugLoginData') || '[]';
        return JSON.parse(data);
      },
      set (val) {
        localStorage.setItem('LetsDebugLoginData', JSON.stringify(val));
      }
    }
  },
  methods: {
    ...mapActions("Auth", ["Auth_login"]),
    async login(item) {
      await this.Auth_login(item);
      this.$router.push({ name: "Home" });
      if (this.closeDialogAfterLogin) this.$emit("closeDialog");
    },
    async updateLetsDebugLoginData() {
      await this.$dialog.prompt({
        title: "Update LetsDebugLoginData",
        text: "Enter new data in JSON format",
        value: JSON.stringify(this.LetsDebugLoginData, null, 2),
      }).then((result) => {
        if (result) {
          try {
            this.LetsDebugLoginData = JSON.parse(result);
            this.$dialog.notify.success("Reload the page to show the updated data");
          } catch (e) {
            this.$dialog.notify.error("Invalid JSON format");
          }
        }
      });
    },
    async loginWithCustomNo(prefix) {
      const input = this.$refs.customLoginNo.internalValue;
      if (!input) {
        this.$dialog.notify.error("Please enter a value");
        return;
      }
      this.$refs.customLoginNo.internalValue = "";
      await this.login({ user_id: `${prefix}${input}` });
    },
    async loginWithUserId() {
      const input = this.$refs.customLoginUserId.internalValue;
      if (!input) {
        this.$dialog.notify.error("Please enter a value");
        return;
      }
      this.$refs.customLoginUserId.internalValue = "";
      await this.login({ user_id: input });
    },
  },
};
</script>

<style scoped>
.login-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}
.login-grid-item {
  cursor: pointer;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.login-grid-item:hover {
  background-color: #f0f0f0;
}
</style>
